import React, { useCallback } from "react";
import { GlobalBox } from "components/Box/GlobalBox";
import { useDispatch, useSelector } from "react-redux";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { TableInputs } from "components/CardTable/TableInputs";
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportSalesByNoteFilters, getReportSalesByNoteAction } from "redux/actions/Reports/reportSalesByNote/reportSalesByNoteActions";
import { useSearch } from "hooks/useSearch";

export const ReportSalesByNoteView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(state => state.reportSalesByNote);

  const handleSubmit = useCallback((e, isPdf = true) => {
    e.preventDefault();
    if (!station?.id) {
      setSnackbar("Falta seleccionar planta.", 'warning');
      return;
    }
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    dispatch(getReportSalesByNoteAction({ startDate, endDate, station, isPdf }));
  }, [startDate, endDate, station]);

  return (
    <GlobalBox title="Reporte Ventas por Nota" icon={<AssessmentIcon />}>
      {isLoadingComp?.loadingSalesByNote
        ? <LoadingComponent />
        : <TableInputs
            reducer="reportSalesByNote"
            dates
            stations
            maxDate={newDate()}
            dispatchAction={setReportSalesByNoteFilters}
            submitAction={handleSubmit}
            submitSecond={(e) => handleSubmit(e, false)}
            submitButtonName="PDF"
          />
      }
    </GlobalBox>
  );
};
